import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-bottom: 12px;\n  width: 100%;\n  margin-top: 24px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, TextField } from "@bookips/solvook-ui-library";
import { MenuItem, styled } from "@mui/material";
import { treeItemClasses } from "@mui/x-tree-view";
import { TreeItem2 } from "@mui/x-tree-view/TreeItem2";
export const ButtonWithDropdownMenu = styled(Button)((param)=>{
    let { theme  } = param;
    return {
        border: "1px solid ".concat(theme.palette.grey[100]),
        backgroundColor: "#fff",
        borderRadius: "6px",
        padding: "6px 12px",
        color: theme.palette.grey[500],
        transition: "all 0.3s ease",
        ...theme.typography.regular16,
        svg: {
            marginLeft: "4px"
        },
        '&.selected, [aria-expanded="false"]': {
            fontWeight: 600,
            color: theme.palette.primary["main"],
            backgroundColor: theme.palette.indigo[0],
            borderColor: theme.palette.indigo[200],
            svg: {
                stroke: theme.palette.primary["main"]
            }
        },
        '&[aria-expanded="true"]': {
            fontWeight: 600,
            color: "#fff",
            backgroundColor: theme.palette.primary["main"],
            svg: {
                transform: "rotate(180deg)",
                transition: "all 0.3s ease",
                stroke: "#fff"
            }
        },
        "&:hover": {
            backgroundColor: theme.palette.indigo[0],
            color: theme.palette.primary["main"],
            fontWeight: 600,
            svg: {
                stroke: theme.palette.primary["main"]
            }
        },
        [theme.breakpoints.down("sm")]: {
            "&:not(.selected):hover": {
                backgroundColor: "initial",
                color: theme.palette.grey[500],
                fontWeight: "normal",
                svg: {
                    stroke: theme.palette.grey[500]
                }
            }
        }
    };
});
export const CustomTreeItem = styled(TreeItem2)((param)=>{
    let { theme  } = param;
    return {
        ["& .".concat(treeItemClasses.iconContainer)]: {
            "& .close": {
                opacity: 0.3
            }
        },
        "&.MuiTreeItem-root": {
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            ["& .".concat(treeItemClasses.content)]: {
                padding: "0",
                flexDirection: "row-reverse",
                ":hover": {
                    backgroundColor: "transparent",
                    "& .MuiTreeItem-label": {
                        transition: "all 0.3s",
                        color: theme.palette.text["title"]
                    },
                    i: {
                        svg: {
                            transition: "all 0.3s",
                            stroke: theme.palette.text["title"]
                        }
                    }
                },
                "& .MuiTreeItem-label": {
                    color: theme.palette.text["secondary"],
                    ...theme.typography.body2
                },
                "&.Mui-focused": {
                    backgroundColor: "transparent"
                },
                "&.Mui-expanded": {
                    ".MuiTreeItem-label": {
                        color: theme.palette.text["title"]
                    }
                },
                "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                    "& .MuiTreeItem-label": {
                        fontWeight: "600",
                        color: theme.palette.primary["main"]
                    }
                },
                ["&.Mui-selected)"]: {
                    "& .MuiTreeItem-label": {
                        fontWeight: "600",
                        color: theme.palette.text["title"]
                    }
                }
            }
        },
        "& .MuiCollapse-root": {
            paddingLeft: "16px",
            "& .MuiCollapse-wrapperInner": {
                display: "flex",
                flexDirection: "column",
                gap: "16px"
            }
        }
    };
});
export const CustomTextField = styled(TextField)((param)=>{
    let { theme  } = param;
    return {
        fieldset: {
            border: "none"
        },
        ".MuiInputBase-input": {
            ...theme.typography.body2,
            color: theme.palette.text["secondary"]
        },
        ".MuiOutlinedInput-root": {
            backgroundColor: "transparent",
            "> div": {
                paddingTop: "0px",
                paddingBottom: "0px",
                paddingRight: "20px !important"
            },
            ".MuiSelect-icon": {
                top: "unset",
                color: theme.palette.text["secondary"],
                right: 0
            }
        },
        "& .MuiSelect-root": {
            ".MuiSelect-select": {
                paddingTop: "0",
                paddingBottom: "0"
            }
        }
    };
});
export const CustomSelectMenuItem = styled(MenuItem)((param)=>{
    let { theme  } = param;
    return {
        "&.select": {
            padding: "5px 12px"
        },
        ...theme.typography.body2,
        color: theme.palette.text["secondary"],
        ".MuiMenuItem-root": {
            padding: "5px 12px"
        },
        li: {
            padding: "5px 12px !important"
        }
    };
});
export const CustomSelect = ()=>{
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
CustomSelect.CustomTextField = CustomTextField;
CustomSelect.CustomSelectMenuItem = CustomSelectMenuItem;
export const SearchResultAmount = styled("div")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text["secondary"],
        ...theme.typography.body2
    };
});
export const SearchResultDescWrap = styled("div")(_templateObject());
